import * as React from 'react';

export const Header = () => (
  <nav />
);
